const LINKS = [
  { label: "ABOUT", target: "#about" },
  { label: "PRODUCTS", target: "#products" },
  { label: "CONTACT US", target: "#contact" },
];

export const Footer = ({ onNavigate }) => (
  <footer data-testid="site-footer" className="bg-slate-900 text-white px-6 md:px-12 pt-24 pb-10">
    <div className="max-w-[1400px] mx-auto">
      <div className="flex flex-wrap items-end justify-between gap-10 pb-16 border-b border-white/10">
        <div>
          <p className="font-display text-5xl sm:text-6xl tracking-tight">TrioDocz<span className="text-slate-500">.</span></p>
          <p className="mt-4 text-sm text-slate-400 max-w-sm leading-relaxed">
            Visa documentation, done properly. Prepared by humans, checked
            twice, delivered fast.
          </p>
        </div>
        <nav className="flex flex-col sm:flex-row gap-5 sm:gap-10" data-testid="footer-nav">
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => onNavigate(l.target)}
              className="text-left text-xs font-semibold tracking-[0.2em] text-slate-400 hover:text-white transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
      </div>
      <div className="pt-8 flex flex-wrap items-center justify-between gap-4">
        <p className="text-xs text-slate-500">© 2026 Triodocz · triodocz.com</p>
        <p className="text-xs text-slate-600 max-w-md">
          Triodocz is a private documentation consultancy and is not
          affiliated with any government or embassy.
        </p>
      </div>
    </div>
  </footer>
);
